import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { ArrowRight } from 'lucide-react';

const COPY = {
  fr: {
    title: 'Parlons de vos routes et de vos volumes',
    desc: 'Décrivez votre activité, nous vous montrons la plateforme sur vos cas réels. '
      + 'Sans engagement.',
    primary: 'Demander une démo',
    secondary: 'Créer mon entreprise',
  },
  en: {
    title: 'Let us talk about your routes and volumes',
    desc: 'Describe your operations and we will show the platform on your real cases. '
      + 'No commitment.',
    primary: 'Request a demo',
    secondary: 'Create my company',
  },
};

const CTASection = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const copy = COPY[language === 'en' ? 'en' : 'fr'];

  return (
    <section className="landing-cta">
      <div className="landing-cta-inner">
        <h2>{copy.title}</h2>
        <p>{copy.desc}</p>
        <div className="landing-cta-buttons">
          <button onClick={() => navigate('/contact')} className="btn-primary">
            {copy.primary}
            <ArrowRight size={16} />
          </button>
          <button onClick={() => navigate('/register-company')} className="btn-secondary">
            {copy.secondary}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
